import React, { Component } from "react";
import { Grid, Container, Loader, Dimmer, Message } from "semantic-ui-react";

import SideNav from "./SideNav";
import Main from "./Main";
import Heading from "../../components/Header";
import History from "./History";
import fire from "../../config/config";
import * as moment from "moment";
import { Redirect } from "react-router-dom";
import Iframe from "react-iframe";
class UserDashboard extends Component {
  state = {
    activeItem: "home",
    loading: true,
    history: [],
    errMsg: null,
    activated: null,
    redirect: false,
    userName: ''
  };

  componentDidMount() {
    //get the currentUser
    //this.setState({loading: true})
    fire.auth().onAuthStateChanged(user => {
      //console.log("user:", user);

      if (user !== null) {
        //console.log("email:", user.email);
        //get the history
        this.setState({ loading: false });
        fire
          .database()
          .ref("/users")
          .orderByChild("email")
          .equalTo(user.email)
          .on("value", snap => {
            let data = snap.val();
            //console.log(data);
            let history = [];
            let activated;
            let userName;
            for (let d in data) {
              userName = data[d].name
              //check if history is there
              if (data[d].history !== undefined) {
                for (let i in data[d].history) {
                  history.unshift(data[d].history[i]);
                }
              }
              activated = data[d].activated;
            }
            //send the history into state
            this.setState({
              history: history,
              loading: false,
              activated: activated,
              userName:userName
            });
          });
      } else {
        this.setState({
          redirect: true,
          errMsg:
            "error, no history avaible, please wait until your bought packages get confirmed!",
          loading: false
        });
      }
    });
  }

  handleItemClick = (e, { name }) => this.setState({ activeItem: name });

  countDown(activatedAt, pckg, index) {
    //const { history } = this.state;
    //check if each package that has been bought
    //has reached 7days and less than 6 weeks
    //and show an alert that he is going to
    //receive payment for it
    //return <div key={index}>Hey, ooonh!</div>;
    if (activatedAt === undefined || pckg === undefined) {
      return null;
    }

    var timeNow = new Date().getTime();

    if (moment(timeNow) <= moment(activatedAt).add(6, "weeks")) {
      //filter those still active, less than 6 weeks
      var week = 0;
      for (let i = 1; i <= 6; i++) {
        if (moment(timeNow) <= moment(activatedAt).add(i, "weeks")) {
          week = i;
          break;
        }
      }
      //daysLeft =moment(timeNow)
      //.to(moment(h.activatedAt).add(week, "weeks"))
      return (
        <Message positive key={index}>
          <p>
            You're receiving your payment #{week} for the {pckg + "$ "}
            package activated on {" " + moment(activatedAt).format("LLLL")}
            <b>
              {", " +
                moment(timeNow).to(moment(activatedAt).add(week, "weeks")) +
                "."}
            </b>
          </p>
        </Message>
      );
    } else return null;
  }

  render() {
    const {
      activeItem,
      loading,
      history,
      errMsg,
      redirect,
      userName
    } = this.state;

    if (loading) {
      return (
        <Dimmer active inverted>
          <Loader size="large">Loading</Loader>
        </Dimmer>
      );
    }

    if (redirect) {
      return <Redirect to="/login" />;
    }

    return (
      <Container>
        <Grid>
          <Grid.Row style={{ marginBottom: 10 }}>
            <Heading />
          </Grid.Row>
          <Grid.Row columns={16}>
            <div style={{ paddingTop: 20 }}>
              <Iframe
                url="https://widget.coinlib.io/widget?type=horizontal&theme=light&pref_coin_id=1505&invert_hover=no"
                width="1400px"
                height="45px"
                id="myId"
                className="myClassname"
                display="initial"
                position="relative"
              />
            </div>
          </Grid.Row>
          <Grid.Row columns={2}>
            <Grid.Column width={3}>
              <SideNav
                handleItemClick={this.handleItemClick}
                activeitem={activeItem}
              />
            </Grid.Column>
            <Grid.Column width={13}>
              <div>
                {loading ? (
                  <Dimmer active inverted>
                    <Loader size="large">Loading</Loader>
                  </Dimmer>
                ) : activeItem === "home" ? (
                  <Main userName={userName} />
                ) : (
                  <History errMsg={errMsg} history={history} />
                )}
                {history.map((h, i) => {
                  return this.countDown(h.time, h.pckg, i);
                })}
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default UserDashboard;



// WEBPACK FOOTER //
// ./src/views/UserDash/UserDashboard.js